// extracted by mini-css-extract-plugin
export var arrowWrapper = "cR_ch";